import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import ScheduleFormFields from './ScheduleFormFields'

class ScheduleForm extends React.Component {

    render() {

        return <ScheduleFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            status: 'I',
            id_course: props.course.id,
            id_person: '',
            room: '',
            day: '',
            start: '',
            end: '',
            topic: '',
            lecturer: null,
        });
    },

    // validationSchema: () => {
    //     let rules = object().shape({
    //         first_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
    //         ),
    //         last_name: string().required(
    //             i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')})
    //         ),
    //     });

        // todo: company nur validieren wenn checkbox angehakt
        // company_name: string().required(
        //     i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
        // )

        // return rules
    // },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('schedules.save_success'),
                text: i18n.get('schedules.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('schedules.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(ScheduleForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Schedules/ScheduleForm.js